import axios from "axios";
import { API_GET_WATER_MODEL_DATA } from "../../config/api";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  FETCH_WATER_MODELS_DATA_REQUEST,
  fetchWaterModelsDataFailure,
  fetchWaterModelsDataSuccess,
} from "../../store/actions/waterModelData.actions";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";

const getWaterModelData = async (token, waterThing) => {
  const url = `${API_GET_WATER_MODEL_DATA}?thing=${waterThing}`;
  const headers = {
    "content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const response = await axios.get(url, { headers });
  return response.data;
};

function* handleWaterModelData(action) {
  try {
    yield put(showProgress());
    const token = yield select((state) => state.auth.token);
    const thing = action?.payload;
    const response = yield call(getWaterModelData, token, thing);
    yield put(fetchWaterModelsDataSuccess(response));
    yield put(hideProgress());
  } catch (error) {
    yield put(
      showAlertInfo({ type: alertInfoTypes.ERROR, message: error.message })
    );
    yield put(hideProgress());
    yield put(fetchWaterModelsDataFailure(error.message));
  }
}

export function* watchGetWaterModelData() {
  yield takeLatest(FETCH_WATER_MODELS_DATA_REQUEST, handleWaterModelData);
}
